import React from "react";
import theme from "@monorepo/styles/theme";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export type TStyledSvgIconWrapper = SvgIconProps & {
  active?: boolean;
  activeColor?: string;
  strokeWidth?: string | number;
  monochrome?: boolean;
};

const StyledSvgIcon = styled(SvgIcon, {
  shouldForwardProp: (prop) =>
    prop !== "active" && prop !== "usesFill" && prop !== "strokeWidth" && prop !== "activeColor",
})<TStyledSvgIconWrapper>(({ active, strokeWidth, activeColor }) => ({
  "& .stroke": {
    fillRule: "even-odd",
    fill: "none",
    stroke: active ? (activeColor ? activeColor : theme.palette.primary.contrastText) : undefined,
    strokeWidth: strokeWidth ? strokeWidth : "3px",
    strokeMiterlimit: 10,
  },
  "& .fill": {
    strokeWidth: strokeWidth ? strokeWidth : 1,
    strokeMiterlimit: 10,
    fill: active ? (activeColor ? activeColor : theme.palette.primary.contrastText) : undefined,
  },
  verticalAlign: "middle",
}));

const StyledSvgIconWrapper: React.FC<TStyledSvgIconWrapper> = (props) => {
  const { active, activeColor = theme.palette.primary.contrastText, ...other } = props;
  return <StyledSvgIcon {...other} active={active} activeColor={activeColor} viewBox={props.viewBox} />;
};
export default StyledSvgIconWrapper;
